import { Link } from "react-router-dom";
import { ClipboardPlus, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function EmptyState({ title = "No rework requests yet", body, testid = "empty-state" }) {
  const { user } = useAuth();
  const canSubmit = !["management", "kiosk"].includes(user?.role);
  return (
    <div className="border border-dashed border-[#cfcfc9] bg-white rounded-sm px-8 py-14 text-center" data-testid={testid}>
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#efece5] text-[#647265]">
        <ClipboardPlus size={26} aria-hidden="true" />
      </div>
      <div className="font-display text-xl font-bold text-[#232826]">{title}</div>
      <p className="mx-auto mt-2 max-w-md text-sm text-[#6b6a68]">
        {body || "The register is empty. Submit your first rework request and it will appear here, on the Board and in the daily Teams digest."}
      </p>
      {canSubmit ? (
        <Link to="/new" data-testid={`${testid}-cta`}
          className="mt-6 inline-flex items-center gap-2 rounded-sm bg-[#424e43] px-5 py-3 text-xs font-semibold uppercase tracking-wide text-[#f7f5f1] transition-colors hover:bg-[#232826]">
          Submit your first rework request <ArrowRight size={14} aria-hidden="true" />
        </Link>
      ) : (
        <p className="mt-6 text-xs text-[#a39f98]">Production staff or leads can submit the first request from New Request.</p>
      )}
    </div>
  );
}
